export const loginService = {
    CheckLogin: (data) => window.axios.post('login', data),
    CheckLogout: (data) => window.axios.post('logout', data),
    ChangePassword: (data) => window.axios.post('change_password', data),
    ForgotPassword: (data) => window.axios.post('forgot_password', data),
};